import { Moon, Sun, Monitor } from "lucide-react"

import { useTheme } from "./ThemeProvider"
import { cn } from "@/lib/utils"

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, setTheme } = useTheme()

  const items: { id: "light" | "dark" | "system"; icon: React.ReactNode; label: string }[] = [
    { id: "light", icon: <Sun className="h-3.5 w-3.5" />, label: "Claro" },
    { id: "dark", icon: <Moon className="h-3.5 w-3.5" />, label: "Escuro" },
    { id: "system", icon: <Monitor className="h-3.5 w-3.5" />, label: "Sistema" },
  ]

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-md border bg-background p-0.5",
        className
      )}
      role="radiogroup"
      aria-label="Tema"
    >
      {items.map((item) => {
        const active = theme === item.id
        return (
          <button
            key={item.id}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={item.label}
            onClick={() => setTheme(item.id)}
            className={cn(
              "flex h-7 w-7 items-center justify-center rounded transition-colors",
              active
                ? "bg-foreground text-background"
                : "text-muted-foreground hover:text-foreground"
            )}
            title={item.label}
          >
            {item.icon}
          </button>
        )
      })}
    </div>
  )
}
